import {
  Component,
  Input,
  ChangeDetectionStrategy,
  forwardRef,
  OnInit
} from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/distinctUntilChanged';

import { getValue } from 'microedge-rxstate/dist/helpers';
import { ListPagingComponent } from '../list/list-paging.component';
import { ListState, ListStateDispatcher, ListItemModel } from '../list/state';
import {
  ListPagingSetMaxPagesAction,
  ListPagingSetItemsPerPageAction,
  ListPagingSetPageNumberAction
} from '../list/state/paging/actions';

import {
  AsyncList
} from 'microedge-rxstate/dist';


export class SkyListPagingComponent extends ListPagingComponent implements OnInit {
  
  public pageSize: Observable<number> | number = 10;

  
  public maxPages: Observable<number> | number = 5;

  
  public pageNumber: Observable<number> | number = 1;

  public currentPageNumber: Observable<number>;

  public maxDisplayedPages: Observable<number>;

  public itemsPerPage: Observable<number>;

  public itemCount: Observable<number>;

  constructor(
    state: ListState,
    dispatcher: ListStateDispatcher
  ) {
    super(state, dispatcher);
  }

  public ngOnInit() {

    this.currentPageNumber = this.state.map(s => s.paging.pageNumber);

    this.maxDisplayedPages = this.state.map(s => s.paging.maxDisplayedPages);

    this.itemsPerPage = this.state.map(s => s.paging.itemsPerPage);

    this.itemCount = this.state.map((s) => {
      return s.items;
    })
    .scan((previousValue: AsyncList<ListItemModel>, newValue: AsyncList<ListItemModel>) => {
      if (previousValue.lastUpdate > newValue.lastUpdate) {
        return previousValue;
      } else {
        return newValue;
      }
    })
    .map((result: AsyncList<ListItemModel>) => {
      return result.count;
    })
    .distinctUntilChanged();

    // subscribe to or use inputs
    getValue(this.pageSize, (pageSize: number) =>
      this.dispatcher.next(
        new ListPagingSetItemsPerPageAction(Number(pageSize))
      )
    );
    getValue(this.maxPages, (maxPages: number) =>
      this.dispatcher.next(
        new ListPagingSetMaxPagesAction(Number(maxPages))
      )
    );
    getValue(this.pageNumber, (pageNumber: number) =>
      this.dispatcher.next(
        new ListPagingSetPageNumberAction(Number(pageNumber))
      ));
  }

  public pageChange(currentPage: number) {
    this.dispatcher.next(
      new ListPagingSetPageNumberAction(Number(currentPage))
    );
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-list-paging',
  template: `<div>
  <sky-paging
    [pageSize]="itemsPerPage | async"
    [maxPages]="maxDisplayedPages | async"
    [currentPage]="currentPageNumber | async"
    [itemCount]="itemCount | async"
    (currentPageChange)="pageChange($event)"
    >
  </sky-paging>
</div>
`,
  providers: [
    /* tslint:disable */
    { provide: ListPagingComponent, useExisting: forwardRef(() => SkyListPagingComponent)}
    /* tslint:enable */
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ListState, },
{type: ListStateDispatcher, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'pageSize': [{ type: Input },],
'maxPages': [{ type: Input },],
'pageNumber': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
